import { DefaultButton, Icon, IContextualMenuItem } from "@fluentui/react";
import logo from "../../../assets/images/logo.png";
import logo2 from "../../../assets/images/logo2.png";

import profileLogo from "../../../assets/images/profile2.png";
import contactLogo from "../../../assets/images/contact.png";

import orderLogo from "../../../assets/images/order.png";
import invoiceLogo from "../../../assets/images/invoice.jpg";
import paymentLogo from "../../../assets/images/payment.png";

import productLogo from "../../../assets/images/products.png";
import productAdminLogo from "../../../assets/images/products-admin.png";

import printLogo from "../../../assets/images/print.png";
import passwordLogo from "../../../assets/images/password.jpg";
import logoutLogo from "../../../assets/images/logout.png";

import { UserRolesModel } from '../../accounts/models/UserRolesInfo';
import { AccountService } from "../../accounts/services/AccountService";
import { BannerInfo } from '../../home/models/BannerInfo';
import { Authentication } from "./Authentication";
import { RouteUtils } from "./RouteUtils";
import { Utils } from './Utils';
import ProductSearchView from "../../products/views/users/ProductSearchView";

export type MenuProps = {
    banners: BannerInfo[];
    cartId: number;
    getCartCountText: () => string;
}

export default function MenuView({ banners, cartId, getCartCountText }: MenuProps) {
    const width4 = Utils.getColumnWidth(4);
    const width4R = Utils.getColumnWidth(4, 4, 8);

    const userRoles: UserRolesModel = Authentication.getUserRoles();

    const url = window.location.href.toLowerCase();
    const isMobile = window.innerWidth <= 500;
    let height = 60;
    let iconHeight = 50;
    const logoSize = 32;

    const createMenuItems = (): IContextualMenuItem[] => {
        let items: IContextualMenuItem[] = [];

        if (Authentication.isLoggedIn()) {
            items.push({
                key: 'profiles',
                text: 'Profiles',
                iconProps: { iconName: "" },
                onClick: () => { window.open('/profiles', "_self"); },
                onRenderIcon: () => (
                    <img src={profileLogo} alt="" width={logoSize} height={logoSize} />
                )
            });

            items.push({
                key: 'contacts',
                text: 'Contacts',
                iconProps: { iconName: "" },
                onClick: () => { window.open('/contacts', "_self"); },
                onRenderIcon: () => (
                    <img src={contactLogo} alt="" width={logoSize} height={logoSize} />
                )
            });

            items.push({
                key: 'order',
                text: 'Orders',
                iconProps: { iconName: "" },
                onClick: () => { window.open('/orders', "_self"); },
                onRenderIcon: () => (
                    <img src={orderLogo} alt="" width={logoSize} height={logoSize} />
                )
            });

            items.push({
                key: 'invoice',
                text: 'Invoices',
                iconProps: { iconName: "" },
                onClick: () => { window.open('/invoices', "_self"); },
                onRenderIcon: () => (
                    <img src={invoiceLogo} alt="" width={logoSize} height={logoSize} />
                )
            });

            items.push({
                key: 'payment',
                text: 'Payments',
                iconProps: { iconName: "" },
                onClick: () => { window.open('/payments', "_self"); },
                onRenderIcon: () => (
                    <img src={paymentLogo} alt="" width={logoSize} height={logoSize} />
                )
            });

            items.push({
                key: 'products',
                text: 'Products',
                iconProps: { iconName: "" },
                onRenderIcon: () => (<img src={productLogo} alt="" width={logoSize} height={logoSize} />),
                onClick: () => { window.open('/products', "_self"); }
            })

            if (userRoles.isSalesperson) {
                items.push({
                    key: 'admin-products',
                    text: 'Admin - Products',
                    iconProps: { iconName: "" },
                    onRenderIcon: () => (<img src={productAdminLogo} alt="" width={logoSize} height={logoSize} />),
                    onClick: () => { window.open('/admin-products', "_self"); }
                })

                items.push({
                    key: 'print-invoices',
                    text: 'Print Invoices',
                    iconProps: { iconName: "" },
                    onRenderIcon: () => (<img src={printLogo} alt="" width={logoSize} height={logoSize} />),
                    onClick: () => { window.open('/invoice-print', "_self"); }
                })
            }

            items.push({
                key: 'change-password',
                text: 'Change Password',
                iconProps: { iconName: "" },
                onClick: RouteUtils.goChangePassword,
                onRenderIcon: () => (
                    <img src={passwordLogo} alt="" width={logoSize} height={logoSize} />
                )
            });

            items.push({
                key: 'logout',
                text: 'Logout',
                iconProps: { iconName: "" },
                onClick: onLogout,
                onRenderIcon: () => (
                    <img src={logoutLogo} alt="" width={logoSize} height={logoSize} />
                )
            });
        } else {
            items.push({
                key: 'login',
                text: 'Login',
                iconProps: { iconName: "" },
                onClick: RouteUtils.goLogin,
                onRenderIcon: () => (
                    <img src={logo} alt="" width={logoSize} height={logoSize} />
                )
            });
        }

        return items;
    }

    const onLogout = () => {
        const service = new AccountService();
        service.logout();
        Authentication.clearUserAuth();
        RouteUtils.goHome();
    }

    const menuView = () => {
        return <>
            <DefaultButton
                menuProps={{
                    shouldFocusOnMount: true,
                    items: createMenuItems(),
                    calloutProps: {
                        calloutWidth: 230,
                        styles: {
                            // Makes the white panel container have curved borders
                            calloutMain: {
                                borderRadius: 10,
                                //overflow: 'hidden', // Ensures inner items respect the curve
                                padding: 10
                            },
                        },
                    }
                }}
                className="my-context-menu context-menu-text primary-color"
                styles={{
                    root: { minWidth: 40, width: 40, border: "none" },
                    menuIcon: { display: "none !important" }
                }}>
                <Icon iconName="Contact" style={{ fontSize: "x-large" }} />
            </DefaultButton>
        </>;
    }

    const iconDesktop = () => {
        return <div className="container cursor" onClick={RouteUtils.goHome} style={{ maxWidth: 250 }}>
            <img src={logo2} alt="Arina" height={iconHeight} />
            {/*<span className="brand-name">Arina</span>*/}
        </div>
    }

    const iconMobile = () => {
        return <>
            <img src={logo} alt="Arina" onClick={RouteUtils.goHome} width={iconHeight} />
        </>;
    }

    const goCart = () => {
        window.open("/carts/" + cartId, "_self");
    }

    const goFavorite = () => {
        window.open("/favorites", "_self");
    }

    const cartButton = () => {
        const count = getCartCountText();

        return <span className="cart-button pointer" onClick={goCart}>
            <Icon iconName="ShoppingCart" className="cart-item" />
            {!Utils.isNullOrEmpty(count) && < span className="cart-qty">{count}</span>}
        </span>
    }

    const favorithButton = () => {
        return <Icon iconName="Heart" className="pointer" onClick={goFavorite} />
    }

    const rightView = () => {
        if (!Utils.isNullOrEmpty(userRoles.displayName)) {
            return <div className={"container"} style={{ height: height, display: "inline-flex", fontSize: "x-large" }}>
                <span>{menuView()}</span>
                <span className={"pt-5 ph-10"}>{favorithButton()}</span>
                {<span className="pl-5">{cartButton()}</span>}
            </div>;
        }

        return <div className="right pt-15 mb-5 mr--5 font-large">
            <span
                className="primary-color cursor"
                onClick={() => window.open("/login", "_self")}
            >Log In</span>
        </div>
    }

    return <div className="ms-Grid" style={{ background: "black" }}>
        <div className={"ms-Grid-row primary-color ph-15"}>
            <div className={width4 + " container ph-0 left"} style={{ height: height }}>
                {isMobile && iconMobile()}
                {!isMobile && iconDesktop()}
            </div>

            {!isMobile && <div className={width4 + " center "} style={{ paddingTop: 13 }}>
                <ProductSearchView />
            </div>}

            <div className={width4R + " right"} style={{ height: height }}>
                {rightView()}
            </div>
        </div>
    </div>;
}